import React, { Component } from 'react'
import UploadService from "./service";


import CommonFile from '../models/commonFile'
import CommonTree from '../models/commonTree'
import Table from '../table/table'
import VideoAudioUpload from '../upload/ecology-upload/videoaudio.upload'
import MultipleLevelCascader from '../multipleLevelCascader/index'


import FileTypePopover from './fileTypePopover'

import {Modal,Button,Select,Progress,Popover,Icon,Switch,message} from "antd"

import './style.less'

import {ResourceUtil} from './file.type'

interface iProps {
    onCancel: () => void; // 点击关闭弹窗的回调
    visible: boolean; // 弹窗的状态
    showSwitch?: boolean, // 是否展示上传至资源库的switch
    resourceCategoryApi?: string, // 获取资源分类列表，可以不传(默认是：/leco/ecology/api/v1/categoryMgr/info/getCategoryTreeNode)
    hasResourceCategory?: boolean, // 是否有上传至资源分类选项
    maxFileLength?: number, 
    uploadFile: (file: any) => void, // 每次上传成功的回调（上传成功的文件的详细信息）
    filePatten?: string, 
    // 上传文件类型的正则表达式
    // 默认是视频：(.wmv|.wm|.asf|.asx|.rm|.rmvb|.ra|.ram|.mpg|.mpeg|.mpe|.vob|.dat|.mov|.3gp|.mp4|.mp4v|.m4v|.mkv|.avi|.flv|.f4v|.mts)$
    // 音频：（.wav|.aif|.aiff|.au|.snd|.voc|.mp3|.ra|.mid|.rmi|.wma|.ape|.flac|.acc|.m4a|.vqf)$
    // 文档：（.pdf|.ppt|.pptx|.doc|.docx|.xls|.xlsx|.txt|.jpg|.png|.jpeg|.zip|.rar)$
    showType?: string, // 弹窗类型（VIDEO-视频，AUDIO-音频，DOCUMENT-文档（包括文档、图片、压缩包等），RESOURCE-资源（综合））
    uploadway?: string // DEFAULT（默认-资源分类选择下拉框在外面）/NEWMODAL（新弹窗打开选择资源分类并上传）/NONE（无资源分类）
}
interface iState {
    fileList: any[],
    target: string[],
    switchChecked: boolean,
    hasResourceColumns: any[],
    notResourceColumns: any[],
    uploadList: any[],
    uploadStatus: boolean, // 是否正在上传中
    resourceCategoryList: CommonTree[],
    modalShow: any,
    resourceModalVisible: boolean
}
const {Option} = Select
export default class index extends Component<iProps, iState> {
    private uploadService: UploadService = new UploadService();
    state: iState = {
        fileList: [],
        target: [],
        switchChecked: true,
        hasResourceColumns: [
            {
                title: `${this.props.showType === 'VIDEO' ? 
                '视频': 
                (this.props.showType === 'AUDIO' ? '音频' : 
                (this.props.showType === 'DOCUMENT' ? '文档' : '资源'))}名称`,
                dataIndex: "fileName",
                key: "fileName",
                width: '40%',
                render : (text, record:any) => {
                    return <div className={`uploadItem_name ${record.fileType ==='DOCUMENT' ? `portal-DOCUMENT ${record.suffix}`: `portal-${record.fileType}`}`}>
                            {record.fileName}
                        </div>
                }
            },
            {
                title: "文件大小",
                width: '20%',
                render : (text, record:any) => {
                    return <div>{ResourceUtil.getFileSize(record.commonFile?.size??0)}</div>
                }
            },
            {
                title: "资源分类",
                dataIndex: "categoryName",
                key: "categoryName",
                width: '20%'
            },
            {
                title: "上传进度",
                width: '20%',
                render : (text, record:any) => {
                    return this.showUploadRate(record)
                }
            }
        ],
        notResourceColumns:[
            {
                title: `${this.props.showType === 'VIDEO' ? '视频': (this.props.showType === 'AUDIO' ? '音频' : (this.props.showType === 'DOCUMENT' ? '文档' : '资源'))}名称`,
                dataIndex: "fileName",
                key: "fileName",
                width: '50%',
                render : (text, record:any) => {
                    return <div className={`uploadItem_name ${record.fileType ==='DOCUMENT' ? `portal-DOCUMENT ${record.suffix}`: `portal-${record.fileType}`}`}>
                                {record.fileName}
                            </div>
                }
            },
            {
                title: "文件大小",
                width: '20%',
                render : (text, record:any) => {
                    return <div>{ResourceUtil.getFileSize(record.commonFile?.size??0)}</div>
                }
            },
            {
                title: "上传进度",
                width: '30%',
                render : (text, record:any) => {
                    return this.showUploadRate(record)
                }
            }
        ],
        uploadList: [],
        uploadStatus: false,
        resourceCategoryList: [],
        modalShow: {},
        resourceModalVisible: false
    }
    changeTarget = async (target) => {
        this.setState({target})
    }
    changeSwitch = async () => {
        await this.setState({switchChecked: !this.state.switchChecked})
        if (!this.state.switchChecked) {
            this.setState({target: []})
        }
    }
    // 获取上传列表的上传进度
    showUploadRate = (uploadItem: any) => {
        const antIcon = <Icon type="loading" style={{ fontSize: 18 }} spin />
        if (uploadItem) {
            if (uploadItem.uploadStatus === 'successful') {
                return <div className="upload_item_successful">上传成功</div>
            } else if (uploadItem.uploadStatus === 'failed') {
                return <div className="upload_item_failed">上传失败</div>
            } else if (uploadItem.uploadStatus === 'pending') {
                return uploadItem.uploadType === 'split'? 
                    <div className="upload_item_pending">
                        <Progress percent={Number(((uploadItem.completeRequest/uploadItem.totalRequest)*100).toFixed(1))} />
                    </div>: (uploadItem.uploadType === 'normal' ? 
                    <Progress percent={Math.ceil(Math.random()*0.9*100)} />
                    :
                    '-')
            }
        }
    }
    // 获取改变后的视频上传组件的状态
    changeUploadDisableState = (uploadStatus: boolean) => {
        this.setState({uploadStatus})
    }
    private getList = (data, alist?) => {
        let list = alist || [];
        for (let item of data) {
            list.push(item);
            if (item.subNodes && item.subNodes.length) {
                list = this.getList(item.subNodes, list);
            }
        }
        return list;
    };
    // 获取当前正在上传的文件（上传中（上传进度）、上传成功、上传失败）
    getCurrentUploadFile = async (currentItem: any) => {
        // console.log(currentItem)
        this.setState({resourceModalVisible: false})
        // 获取target
        let categoryId = '', categoryName = '', uploadFileItem:any = {}
        if (this.state.switchChecked && this.state.target.length && this.props.uploadway !== 'NONE') {
            categoryId = this.state.target[this.state.target.length - 1]
            let list = this.getList(this.state.resourceCategoryList)
            categoryName = list.find(item => item.id === categoryId).name
        }
        if (this.state.uploadList && this.state.uploadList.length) {
            let sameFile = this.state.uploadList.filter(item => item.fileId === currentItem.fileId)
            if (sameFile && sameFile.length) {
            // console.log(categoryId)
                let uploadList = this.state.uploadList.map(item => {
                    if (item.fileId === currentItem.fileId) {
                        uploadFileItem = {...item, ...currentItem, categoryId, categoryName}
                        item = uploadFileItem
                    }
                    return item
                })
                this.setState({uploadList})
            } else {
            // console.log(categoryId)
                let uploadList = this.state.uploadList
                uploadFileItem = {...currentItem, categoryId, categoryName}
                uploadList.push(uploadFileItem)
                this.setState({uploadList})
            }
        } else {
            uploadFileItem = {...currentItem, categoryId, categoryName}
            this.setState({uploadList: [uploadFileItem]})
            // console.log(categoryId)
        }
        // console.log(categoryId)
        if (uploadFileItem.uploadStatus === 'successful') {
            let {commonFile} = uploadFileItem
            this.props.uploadFile(
                {
                    fileName: uploadFileItem.fileName,
                    fileId: uploadFileItem.fileId,
                    type: uploadFileItem.fileType,
                    categoryId,
                    size: commonFile.size,
                    duration: uploadFileItem.duration,
                    suffix: '.' + uploadFileItem.suffix,
                    ossTypeEnum: uploadFileItem.ossTypeEnum,
                    isPrivate: !(this.state.switchChecked) && this.props.uploadway === 'NEWMODAL',
                    fileUrl: `https://${uploadFileItem.host}/${uploadFileItem.dir}/${uploadFileItem.fileId}`,
                    commonFile: new CommonFile({
                        ...commonFile,
                        contentType: commonFile.type
                    })
                })
        }
    }
    changeFileList = (fileList) => {
        // console.log(1)
        this.setState({fileList})
    }
    // 获取资源分类列表
    getResourceCategoryList = async () => {
        if (this.props.resourceCategoryApi) {
            let resourceCategoryList = await this.uploadService.getResourceCategoryList(this.props.resourceCategoryApi) || []
            this.setState({resourceCategoryList})
        }
    }
    closeUpload = () => {
        let uploading = this.state.uploadList && this.state.uploadList.length && this.state.uploadList.some(item => item.uploadStatus === 'pending')
        if (uploading) {
            message.warning('资源正在上传中，请勿关闭或切换页面！');
            return
        } else {
            this.props.onCancel()
        }
    }
    componentDidMount () {
        let modalShow = ResourceUtil.fileShowMap(this.props.showType)
        this.setState({modalShow})
        this.getResourceCategoryList()
    }
    render() {
        let { visible, showSwitch, hasResourceCategory = true,
            filePatten, showType, maxFileLength, uploadway = "DEFAULT" } = this.props
        let {target, resourceCategoryList, switchChecked,
            hasResourceColumns, notResourceColumns, uploadList, uploadStatus, fileList,
            modalShow, resourceModalVisible} = this.state
        return (
            <Modal
                width="952px"
                title={`上传${modalShow.name}`}
                className="uploadModal"
                maskClosable = {false}
                footer = {null}
                onCancel={this.closeUpload}
                visible={visible}>
                    <div className="uploadModal_operate">
                        <div className="uploadModal_btn">
                            {
                                uploadway === 'NEWMODAL' ?
                                <Button type="primary" onClick={() => {this.setState({resourceModalVisible: true})}} disabled={uploadStatus}>{uploadStatus? '上传中...': `上传${modalShow.name}`}</Button>:
                                <VideoAudioUpload
                                    fileList={fileList}
                                    onChange={this.changeFileList}
                                    children={<Button type="primary" disabled={uploadStatus}>{uploadStatus? '上传中...': `上传${modalShow.name}`}</Button>}
                                    filePatten={filePatten}
                                    checkUploaderUrl='/leco/ecology/api/v1/upload/checkUploader'
                                    changeUploadDisableState={this.changeUploadDisableState}
                                    changeCurrentUploadFile={this.getCurrentUploadFile}
                                    maxFileLength={maxFileLength}></VideoAudioUpload>
                            }
                            <Popover content={<FileTypePopover showType={showType}></FileTypePopover>} title="支持格式详情" trigger="click">
                                <span className="uploadModal_type_list">支持格式<Icon type="question-circle" /></span>
                            </Popover>
                        </div>
                        {uploadway === 'DEFAULT' &&
                        <div className="uploadModal_target">
                            <div>上传至：</div>
                            <MultipleLevelCascader 
                                // placeholder="请选择资源分类" 
                                value={target} 
                                options={resourceCategoryList || []}
                                onChange={this.changeTarget}>
                            </MultipleLevelCascader>
                            {/* <Select placeholder="请选择资源分类" value={target} onChange={this.changeTarget}>
                                {
                                    resourceCategoryList && !!(resourceCategoryList.length) && 
                                    resourceCategoryList.map(item => 
                                        <Option key={item.id} value={item.id}>{item.name}</Option>    
                                    )
                                }
                            </Select> */}
                        </div>}
                    </div>
                    {/* <div className="uploadModal_tip">
                        <div className="uploadModal_tip_text">{modalShow.tip}</div>
                        {showSwitch &&
                        <div>
                            上传至{modalShow.name}库：
                            <Switch checked={switchChecked} onChange={this.changeSwitch} />
                        </div>}
                    </div> */}
                    <div className="uploadModal_fileList">
                        <Table
                            rowKey="fileId"
                            size="middle"
                            dataSource={uploadList}
                            columns={hasResourceCategory ? hasResourceColumns : notResourceColumns}
                            pagination={false}
                        />
                    </div>
                    <Modal
                        width="340px"
                        title={`上传到${modalShow.name}库`}
                        className="resourceUploadModal"
                        maskClosable = {false}
                        footer = {null}
                        // afterClose={() => {this.setState({target: []})}}
                        onCancel={() => {this.setState({resourceModalVisible: false})}}
                        visible={resourceModalVisible}>
                            <div className="resourceUploadModal_form">
                                <div className="resourceUploadModal_form_item">
                                    上传至{modalShow.name}库：
                                    <Switch checked={switchChecked} onChange={this.changeSwitch} />
                                </div>
                                {switchChecked &&
                                <div className="resourceUploadModal_form_item" style={{ marginTop: '12px'}}>
                                    上传{modalShow.name}到：
                                    <MultipleLevelCascader 
                                        // placeholder="请选择资源分类" 
                                        value={target} 
                                        options={resourceCategoryList || []}
                                        onChange={this.changeTarget}>
                                    </MultipleLevelCascader>
                                </div>}
                            </div>
                            
                            <div className="resourceUploadModal_footer">
                                <Button onClick={() => {this.setState({resourceModalVisible: false, target: []})}}>取消</Button>
                                <VideoAudioUpload
                                    fileList={fileList}
                                    onChange={this.changeFileList}
                                    children={<Button type="primary" disabled={uploadStatus}>确定</Button>}
                                    filePatten={filePatten}
                                    checkUploaderUrl='/leco/ecology/api/v1/upload/checkUploader'
                                    changeUploadDisableState={this.changeUploadDisableState}
                                    changeCurrentUploadFile={this.getCurrentUploadFile}
                                    maxFileLength={maxFileLength}
                            ></VideoAudioUpload>
                            </div>
                    </Modal>
            </Modal>
        )
    }
}
